import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Copy, CalendarCheck } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useApi } from "@/api/useApi";

export const PabauBookings = () => {
  const api = useApi();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/pabau/webhook-info").then((r) => setInfo(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(info.webhook_url);
      toast.success("Copied — paste into Pabau's webhook URL field");
    } catch { toast.error("Couldn't copy — select the text manually"); }
  };

  if (!info) return null;

  return (
    <div className="bg-white border border-[#e5e7eb] rounded-[12px] p-6 space-y-4" data-testid="pabau-bookings-card">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-[10px] bg-[#f0f7f8] flex items-center justify-center text-[#3A7A8C] shrink-0">
          <CalendarCheck size={19} weight="fill" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-bold text-[#3C4048]" style={{ fontFamily: "Montserrat" }}>Pabau Bookings</h2>
          <p className="text-[#7A9090] text-sm">
            Wire this up once so new Pabau appointments show up as "Bookings from Social" in Analytics
            — a best-effort attribution to whichever post/link led to it, only when Pabau itself passes along a
            source tag. Without a tag, we can only show a loose time-window correlation, not a guaranteed match.
          </p>
        </div>
      </div>
      <div className="bg-[#fafafa] border border-[#e5e7eb] rounded-[10px] p-3 flex items-center gap-2 min-w-0">
        <code className="text-xs text-[#3C4048] truncate flex-1 min-w-0" data-testid="pabau-webhook-url">{info.webhook_url}</code>
        <Button size="sm" variant="outline" onClick={copyUrl} data-testid="copy-pabau-webhook-btn" className="border-[#e5e7eb] shrink-0 gap-1.5 text-xs h-8">
          <Copy size={13} /> Copy
        </Button>
      </div>
      <ol className="text-[#7A9090] text-xs space-y-1 list-decimal list-inside">
        <li>In Pabau, go to <strong>Setup</strong> → look for <strong>Webhooks</strong> (or under Setup → Integrations → Private Apps if it's not there directly).</li>
        <li>Add a new webhook, set Object Type to <strong>Appointments</strong>, and pick the "created"/"booked" event.</li>
        <li>Paste the URL above as the destination, save, and use Pabau's own "Test" button to confirm it fires.</li>
      </ol>
      {!info.configured && (
        <p className="text-[#a16207] text-xs bg-[#fff8e6] border border-[#f0d98a] rounded-[8px] p-2">
          Pabau API key isn't set on the server yet — the webhook will still receive events, but we won't be able to
          look up appointment details until that's added.
        </p>
      )}
    </div>
  );
};
